import request from "@/request"

/**
 *  登录
 */
export function login(data) {
    return request({
        url: "/login",
        method: 'POST',
        data
    })
}

/**
 *  注册
 */
export function register(user) {
    return request({
        url: "/register",
        method: 'POST',
        data: user
    })
}

/**
 *  获取用户信息
 */
export function getUserInfo() {
    return request({
        url: "/users/currentUser",
        method: 'GET',
    })
}

/**
 *  退出登录
 */
export function logout() {
    return request({
        url: "/Logout",
        method: 'POST',
    })
}